<template>
	<div>
		<div class="container">
			<el-tabs v-model="activeName" @tab-click="handleClick" :class="'custom-tabs-' + activeName">
				<el-tab-pane label="客户质量" name="qualityControl">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange" v-model="query.agentId" filterable
							clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isAdmin || isAgent" v-model="query.companyId" filterable clearable
							placeholder="企业" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query.cardsId" filterable clearable placeholder="请选择品牌"
							class="handle-select mr10" style="width: 140px">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
						<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							class="m_r_10"></el-date-picker>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click.stop="getqualityControl">搜索</el-button>
					</div>
					<div class="card-body">
						<div class="tit">
							<div><i class="el-icon-s-data"></i>通话数据</div>
						</div>
						<div class="card-list">
							<div class="bg_eff5f7">
								<span class="card-list-tit">投诉个数</span>
								<span class="card-list-data">{{totalStats.totalComplaintCount||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">总计费时长（分钟）</span>
								<span class="card-list-data">{{totalStats.totalBilledMinutes||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">诉比<el-tooltip content="诉比=总计费时长（分钟）/投诉个数" placement="top">
										<i class="el-icon-warning-outline"
											style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
									</el-tooltip></span>
								<span class="card-list-data">{{totalStats.totalComplaintRatio||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">付费坐席
									<el-tooltip content="付费坐席" placement="top">
										<i class="el-icon-warning-outline"
											style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
									</el-tooltip>
								</span>
								<span class="card-list-data">{{totalStats.totalSeatCount||0}}</span>
							</div>
						</div>
					</div>
					<el-table :data="tableData" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="agentName" label="代理商" align="center" v-if="isAdmin"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center"
							v-if="isAdmin||isAgent"></el-table-column>
						<el-table-column prop="complaintCount" label="投诉个数" align="center"></el-table-column>
						<el-table-column prop="totalBilledMinutes" label="总计费时长(分钟)" align="center"></el-table-column>
						<el-table-column prop="complaintRatio" label="诉比" align="center"></el-table-column>
						<el-table-column prop="seatCount" label="付费坐席" align="center"></el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query.pageSize" :total="pageTotal" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>

				<el-tab-pane label="通话数据" name="callData">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange2" v-model="query2.agentId"
							filterable clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isAdmin || isAgent" v-model="query2.companyId"
							@change="companyChange2" filterable clearable placeholder="企业" class="handle-select mr10"
							style="width: 260px">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query2.cardsId" filterable clearable placeholder="请选择品牌"
							class="handle-select mr10" style="width: 140px">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
						<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							class="m_r_10"></el-date-picker>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click.stop="getcallData">搜索</el-button>
					</div>
					<div class="card-body">
						<div class="tit">
							<div><i class="el-icon-s-data"></i>通话数据</div>
						</div>
						<div class="card-list">
							<div class="bg_eff5f7">
								<span class="card-list-tit">拨打数量</span>
								<span class="card-list-data">{{overallStats.totalCall||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">接通数量</span>
								<span class="card-list-data">{{overallStats.pickUp||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">接通率</span>
								<span class="card-list-data"
									v-if="overallStats.totalCall!==0">{{(overallStats.pickUp/overallStats.totalCall*100).toFixed(2)||0}}%</span>
								<span class="card-list-data" v-else>0%</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">通话时长(分钟) </span>
								<span class="card-list-data">{{overallStats.carrierCallDuration||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">平均通话时长(秒)
									<el-tooltip content="平均通话时长" placement="top">
										<i class="el-icon-warning-outline"
											style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
									</el-tooltip>
								</span>
								<span class="card-list-data">{{overallStats.averageDuration||0}}</span>
							</div>
						</div>
					</div>
					<el-table :data="tableData2" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="agentName" label="代理商" align="center" v-if="isAdmin"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center"
							v-if="isAdmin||isAgent"></el-table-column>
						<el-table-column prop="cardName" label="行业" align="center"></el-table-column>
						<el-table-column prop="totalCall" label="拨打数量" align="center" sortable></el-table-column>
						<el-table-column prop="pickUp" label="接通数量" align="center" sortable></el-table-column>
						<el-table-column prop="pickUpRate" label="接通率" align="center" sortable>
							<template #default="scope">
								<span>{{ scope.row.pickUpRate||0}}% </span>
							</template>
						</el-table-column>
						<el-table-column prop="carrierCallDuration" label="通话时长(分钟)" align="center"
							sortable></el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query2.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query2.pageSize" :total="pageTotal2" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="套餐订购" name="packageOrder">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange3" v-model="query3.agentId"
							filterable clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isAdmin || isAgent" v-model="query3.companyId"
							@change="companyChange3" filterable clearable placeholder="企业" class="handle-select mr10"
							style="width: 260px">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query3.cardsId" filterable clearable placeholder="请选择品牌"
							class="handle-select mr10" style="width: 140px">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
						<el-date-picker size="small" v-model="timeArr" type="daterange" unlink-panels
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							class="m_r_10"></el-date-picker>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click.stop="getpackageOrder">搜索</el-button>
					</div>
					<div class="card-body">
						<div class="tit">
							<div><i class="el-icon-s-data"></i>套餐订购展示</div>
						</div>
						<div class="card-list">
							<div class="bg_eff5f7">
								<span class="card-list-tit">企业数</span>
								<span class="card-list-data">{{summary.totalEnterprises||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">开通坐席数</span>
								<span class="card-list-data">{{summary.totalSeats||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">订购分钟数(分钟)</span>
								<span class="card-list-data">{{summary.totalUseMinutes||0}}</span>
							</div>
						</div>
					</div>
					<el-table :data="tableData3" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="agentName" label="代理商" align="center" v-if="isAdmin"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center"
							v-if="isAdmin||isAgent"></el-table-column>
						<el-table-column prop="cardName" label="行业" align="center"></el-table-column>

						<el-table-column prop="seatCount" label="付费坐席" align="center" sortable></el-table-column>
						<el-table-column prop="totalUseMinutes" label="购买时长(分钟)" align="center"
							sortable></el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query3.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query3.pageSize" :total="pageTotal3" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>

				<el-tab-pane label="套餐消耗 " name="packageUsageByPageNo" v-if="isAdmin">
					<div class="handle-box">
						<el-select size="small" v-if="isAdmin" @change="agentChange4" v-model="query4.agentId"
							filterable clearable placeholder="代理商" class="handle-select mr10" style="width: 260px">
							<el-option v-for="item in agents" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-if="isAdmin || isAgent" v-model="query4.companyId"
							@change="companyChange4" filterable clearable placeholder="企业" class="handle-select mr10"
							style="width: 260px">
							<el-option v-for="item in companys" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
						<el-select size="small" v-model="query4.cardsId" filterable clearable placeholder="请选择品牌"
							class="handle-select mr10" style="width: 140px">
							<el-option v-for="item in serverLists" :key="item.cardsId" :label="item.cardType"
								:value="item.cardsId"></el-option>
						</el-select>
						<el-date-picker size="small" v-model="timeArr2" type="month" class="m_r_10"></el-date-picker>
						<el-button size="small" type="primary" :class="[theme]" icon="el-icon-search"
							@click.stop="getpackageUsageByPageNo">搜索</el-button>
					</div>
					<div class="card-body">
						<div class="tit">
							<div><i class="el-icon-s-data"></i>套餐消耗数据</div>
						</div>
						<div class="card-list">
							<div class="bg_eff5f7">
								<span class="card-list-tit">套餐分钟数(分钟)</span>
								<span class="card-list-data">{{consumeData.totalMinutes||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">消耗分钟数(分钟)</span>
								<span
									class="card-list-data">{{consumeData.totalMinutes-consumeData.remainderMinutes||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">剩余分钟数(分钟)</span>
								<span class="card-list-data">{{consumeData.remainderMinutes||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">充值金额(元)</span>
								<span class="card-list-data">{{consumeData.totalPrice||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">利润(元)</span>
								<span class="card-list-data">{{consumeData.totalProfit||0}}</span>
							</div>
							<div class="bg_eff5f7">
								<span class="card-list-tit">通话成本(元)</span>
								<span class="card-list-data">{{consumeData.useCost||0}}</span>
							</div>
							<div class="bg_eff5f7" v-if="isAdmin">
								<span class="card-list-tit">残值产能
									<el-tooltip content="残值产能" placement="top">
										<i class="el-icon-warning-outline"
											style="color: #f27c27;position: relative;top:-4px;left: 6px;cursor: pointer;"></i>
									</el-tooltip>
								</span>
								<span class="card-list-data">{{consumeData.residualValue||0}}</span>
							</div>
						</div>
					</div>
					<el-table :data="tableData4" border class="table" ref="multipleTable" max-height="600"
						header-cell-class-name="table-header" @selection-change="handleSelectionChange"
						:header-cell-style="{ 'text-align': 'center' }" :row-style="{ height: '20px' }"
						:cell-style="{ padding: '6px' }" stripe v-loading="loading">
						<el-table-column type="selection" width="55" align="center"></el-table-column>
						<el-table-column prop="agentName" label="代理商" align="center" width="180"
							v-if="isAdmin"></el-table-column>
						<el-table-column prop="companyName" label="企业" align="center" width="300"
							v-if="isAdmin||isAgent"></el-table-column>
						<el-table-column prop="cardName" label="行业" align="center"></el-table-column>
						<el-table-column prop="totalMinutes" label="总时长(分钟)" align="center" sortable></el-table-column>
						<el-table-column prop="remainderMinutes" label="剩余时长(分钟)" align="center"
							sortable></el-table-column>
						<el-table-column label="消耗时长(分钟)" align="center" sortable prop="totalUseMinutes">
						</el-table-column>
						<el-table-column prop="useCost" label="通话成本(元)" align="center" sortable></el-table-column>
						<el-table-column prop="totalPrice" label="充值金额" align="center" sortable></el-table-column>
						<el-table-column prop="totalProfit" label="利润" align="center" sortable></el-table-column>
						<el-table-column prop="residualValue" label="残值产能" align="center" sortable></el-table-column>
					</el-table>
					<div class="pagination">
						<el-pagination background layout="total, sizes, prev, pager, next, jumper"
							:current-page="query4.pageIndex" :page-sizes="[10, 20, 50, 100, 200, 500]"
							:page-size="query4.pageSize" :total="pageTotal4" @size-change="handleSizeChange"
							@current-change="handlePageChange"></el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>

		</div>
	</div>
</template>

<script>
	import {
		qualityControl,
		callData,
		serverList,
		packageOrder,
		packageUsageByPageNo,
		packageUsage
	} from '../../api/setMeal.js';
	import {
		fetchAgent
	} from '../../api/agentIndex.js';
	import {
		fetchCompanyByAgentId,
		fetchDefaultCompanies
	} from '../../api/companyIndex';
	import {
		fetchDepartment,
		fetchUsersByDepartmentId,
		fetchDefaultUsers
	} from '../../api/index.js';
	export default {
		name: 'tonglianPrecisionTube',
		data() {
			return {
				loading: false,
				activeName: 'qualityControl',
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				agents: [],
				companys: [],
				tableData: [],
				query: {
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
					agentId: '',
					companyId: '',
					cardsId: '',
					endTime: '',
					startTime: '',
				},
				totalStats: '',
				pageTotal: 0,
				tableData2: [],
				query2: {
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
					agentId: '',
					companyId: '',
					cardsId: '',
					endTime: '',
					startTime: '',
				},
				pageTotal2: 0,
				overallStats: '',
				tableData3: [],
				query3: {
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
					agentId: '',
					companyId: '',
					cardsId: '',
					endTime: '',
					startTime: '',
				},
				summary: '',
				pageTotal3: 0,
				tableData4: [],
				consumeData: '',
				query4: {
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
					startTime: '',
					agentId: '',
					companyId: '',
					cardsId: '',
				},
				pageTotal4: 0,
				multipleSelection: [],
				isAdmin: false,
				isAgent: false,
				isNormal: false,
				role: '',
				timeArr: [],
				timeArr2: '',
				serverLists: [], //SIPServer服务器的列表

			};
		},
		created() {
			this.role = localStorage.getItem('ms_role');
			if (this.role === 'admin') {
				this.isAdmin = true;
			}
			if (this.role == 'agent') {
				this.isAgent = true;
			}
			if (this.role == 'normal') {
				this.isNormal = true;
			}
			this.init();
			this.getTime();
			this.getServerList();
			this.getqualityControl();
			this.updateTabStyle();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle(){
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			updateTabStyle() {
				// 动态更新样式
				let styleEl = document.getElementById('dynamic-tab-style');
				if (!styleEl) {
					styleEl = document.createElement('style');
					styleEl.id = 'dynamic-tab-style';
					document.head.appendChild(styleEl);
				}

				styleEl.innerHTML = `
			        .el-tabs__active-bar {
			            background-color: ${this.theme8} !important;
			        }
			        .el-tabs__item.is-active {
			            color: ${this.theme8} !important;
			        }
			        .el-tabs__item:hover {
			            color: ${this.theme8} !important;
			            opacity: 0.8;
			        }
			    `;
			},
			handleClick(tab, event) {
				this.activeName = tab.props.name;
				if (tab.props.name == 'qualityControl') {
					this.timeArr = [];
					this.multipleSelection = [];
					this.getTime();
					this.getqualityControl();
				} else if (tab.props.name == 'callData') {
					this.timeArr = [];
					this.multipleSelection = [];
					this.getTime();
					this.getcallData();
				} else if (tab.props.name == 'packageOrder') {
					this.timeArr = [];
					this.multipleSelection = [];
					this.getTime();
					this.getpackageOrder();
				} else if (tab.props.name == 'packageUsageByPageNo') {
					this.timeArr2 = '';
					this.multipleSelection = [];
					this.getTime2();
					this.getpackageUsageByPageNo();
				}
			},
			getTime2() {
				//时间
				this.timeArr2 = new Date(new Date())
			},
			toDateTimeStr2(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				return y + '-' + m;
			},
			getTime() {
				//时间
				let startTime = new Date(new Date());
				let endTime = new Date();
				this.timeArr.push(startTime);
				this.timeArr.push(endTime);
			},
			toDateTimeStr(date) {
				let y = date.getFullYear();
				let m = date.getMonth() + 1;
				let d = date.getDate();
				if (m < 10) {
					m = '0' + m;
				}
				if (d < 10) {
					d = '0' + d;
				}
				return y + '-' + m + '-' + d;
			},

			init() {
				fetchAgent(localStorage.getItem('user')).then(res => {
					this.agents = res.data;
				});
				this.getfetchDefaultCompanies();
			},
			companyChange(companyId) {
				this.query.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},
			companyChange2(companyId) {
				this.query2.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},
			companyChange3(companyId) {
				this.query3.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},
			companyChange4(companyId) {
				this.query4.companyId = companyId;
				let data = {
					companyId: companyId,
					currentUserId: localStorage.getItem('user')
				};
				fetchDepartment(data).then(res => {
					this.departments = res.data;
				});
			},

			// 多选操作
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},

			getfetchDefaultCompanies() {
				this.query.companyId = '';
				let data = {
					currentUserId: localStorage.getItem('user'),
					subAgentId: this.query.subAgentId
				};
				fetchDefaultCompanies(data).then(res => {
					if (this.role == 'company' || this.role == 'department') {
						let data = {
							companyId: '',
							currentUserId: localStorage.getItem('user')
						};
						fetchDepartment(data).then(res => {
							this.departments = res.data;
						});
					} else {
						this.companys = res.data;
					}
				});
			},
			agentChange(agentId) {
				this.query.agentId = agentId;
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},
			agentChange2(agentId) {
				this.query2.agentId = agentId;
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},
			agentChange3(agentId) {
				this.query3.agentId = agentId;
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},
			agentChange4(agentId) {
				this.query4.agentId = agentId;
				if (agentId) {
					let data = {
						subAgent: JSON.parse(localStorage.getItem('subAgent').toLowerCase()),
						agentId: agentId
					};
					fetchCompanyByAgentId(data).then(res => {
						this.companys = res.data;
					});
				} else {
					this.departments = [];
				}
			},
			//sip服务器列表
			getServerList() {
				let data = {
					pageIndex: 1,
					pageSize: 100,
				}
				serverList(data).then(res => {
					if (res?.code === 200) {
						this.serverLists = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getqualityControl() {
				if (this.timeArr === null) {
					this.query.startTime = '';
					this.query.endTime = '';
					this.$message.error('时间不能为空');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query.startTime = startTime;
					this.query.endTime = endTime;
				}
				this.query.userId = localStorage.getItem('user');
				this.loading = true;
				qualityControl(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.companyStats;
						this.pageTotal = res.data.companyStats.lenght;
						this.totalStats = res.data.totalStats;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getcallData() {
				if (this.timeArr === null) {
					this.query2.startTime = '';
					this.query2.endTime = '';
					this.$message.error('时间不能为空');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query2.startTime = startTime;
					this.query2.endTime = endTime;
				}
				this.query2.userId = localStorage.getItem('user');
				this.loading = true;
				callData(this.query2).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData2 = res.data.companyStats.list;
						this.pageTotal2 = res.data.companyStats.total;
						this.overallStats = res.data.overallStats;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getpackageOrder() {
				if (this.timeArr === null) {
					this.query3.startTime = '';
					this.query3.endTime = '';
					this.$message.error('时间不能为空');
				} else {
					let startTime = this.toDateTimeStr(this.timeArr[0]);
					let endTime = this.toDateTimeStr(this.timeArr[1]);
					this.query3.startTime = startTime;
					this.query3.endTime = endTime;
				}
				this.query3.userId = localStorage.getItem('user');
				packageOrder(this.query3).then(res => {
					if (res?.code === 200) {
						this.tableData3 = res.data.enterpriseStats.list;
						this.pageTotal3 = res.data.enterpriseStats.total;
						this.summary = res.data.summary;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getpackageUsageByPageNo() {
				if (this.timeArr2 === null) {
					this.$message.error('时间不能为空');
				} else {
					this.query4.startTime = this.toDateTimeStr2(this.timeArr2);
				}
				this.query4.userId = localStorage.getItem('user');
				this.loading = true;
				packageUsageByPageNo(this.query4).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.getpackageUsage()
						this.tableData4 = res.data.list;
						this.pageTotal4 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			getpackageUsage() {
				packageUsage(this.query4).then(res => {
					if (res?.code === 200) {
						this.consumeData = res.data;
						// this.pageTotal4 = res.data.total;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleSizeChange(val) {
				let actions = {
					qualityControl: () => {
						this.query.pageSize = val;
						this.query.pageIndex = 1;
						this.getTime();
						this.getqualityControl();
					},
					callData: () => {
						this.query2.pageSize = val;
						this.query2.pageIndex = 1;
						this.getTime();
						this.getcallData();
					},
					packageOrder: () => {
						this.query3.pageSize = val;
						this.query3.pageIndex = 1;
						this.getTime();
						this.getpackageOrder();
					},

					packageUsageByPageNo: () => {
						this.query4.pageSize = val;
						this.query4.pageIndex = 1;
						this.getTime2();
						this.getpackageUsageByPageNo();
					},


				};
				if (actions[this.activeName]) {
					actions[this.activeName]();
				}
			},
			// 分页导航
			handlePageChange(val) {
				let actionMap = {
					qualityControl: () => {
						this.query.pageIndex = val;
						this.getTime();
						this.getqualityControl();
					},
					callData: () => {
						this.query2.pageIndex = val;
						this.getTime();
						this.getcallData();
					},
					packageOrder: () => {
						this.query3.pageIndex = val;
						this.getTime();
						this.getpackageOrder();
					},
					packageUsageByPageNo: () => {
						this.query4.pageIndex = val;
						this.getTime2();
						this.getpackageUsageByPageNo();
					},
				};
				// 执行对应的逻辑
				if (actionMap[this.activeName]) {
					actionMap[this.activeName]();
				}

			},
		}
	};
</script>

<style scoped>
	.row-bg {
		padding-right: 12px;
		margin-bottom: 12px;
	}

	.card-body {
		color: rgba(0, 0, 0, 0.65);
		background: #fff;
		border-radius: 2px;
		box-sizing: border-box;
		padding: 24px 0;

	}

	.card-body .tit {
		font-weight: 700;
		color: rgba(0, 0, 0, 0.85);
		margin-bottom: 1em;
		font-size: 14px;
		font-variant: tabular-nums;
		line-height: 1.5;
		list-style: none;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.el-icon-s-data,
	.el-icon-postcard,
	.el-icon-finished {
		font-size: 20px;
		margin-right: 5px;
		color: #1890FF;
	}

	.card-body .card-list {
		display: flex;
		flex-direction: row;
	}

	.card-body .card-list div {
		padding-left: 12px;
		padding-right: 12px;
		padding: 24px;
		zoom: 1;
		width: 23%;
		display: flex;
		flex-direction: column;
		margin-right: 2%;
	}

	.card-body .tit .tit-btn .active {
		color: #fff;
	}

	.card-body .card-list .card-list-tit {
		font-size: 14px;
		color: rgba(0, 0, 0, 0.65);
	}

	.card-body .card-list .card-list-data {
		font-size: 24px;
		margin-top: 10px;
		font-weight: 700;
	}

	.card-body .card-list .card-list-qoq {
		font-size: 12px;
		margin-top: 10px;
	}

	.bg_eff5f7 {
		background: #ecf4ff;
	}

	.bg_dfeef3 {
		background: #dfeef3;
	}

	.bg_A7B3B6 {
		background: #A7B3B6;
	}

	.bg_c9e6f0 {
		background: #c9e6f0;
	}

	.bg_97ADB4 {
		background: #97ADB4;
	}

	.bg_f8f0f9 {
		background: #f8f0f9;
	}

	.bg_f0f2f5 {
		background: #f0f2f5;
	}
</style>